import {Component, Input, OnInit} from '@angular/core';
import {FeatureGroup} from "../../model/feature-group.model";
import {FeatureGroupService} from "../../services/feature-group.service";
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonContent } from "@ionic/angular/standalone";
import { FormsModule } from '@angular/forms';

import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'app-edit-feature-group',
  templateUrl: './edit-feature-group.page.html',
  styleUrls: ['./edit-feature-group.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent
  ]
})
export class EditFeatureGroupPage implements OnInit {

  @Input() featureGroup : FeatureGroup

  constructor(private featureGroupService : FeatureGroupService,
              private modalController : ModalController
              ) { }

  ngOnInit() {
  }


  update = async ()=>{
    const res = await this.featureGroupService.update(this.featureGroup)
    if(res){
      this.modalController.dismiss()
    }
  }
}
